import React from 'react';
import { useDependencies } from '@servicetitan/react-ioc';
import { ServiceFinanceStore } from '../../../stores/service-finance.store';
import { observer } from 'mobx-react';
import { MatField } from 'src/core/components/mat-field';
import classnames from 'classnames';
import Styles from './sign-loan-page.less';

export const SignLoanPage: React.FC = observer(() => {
    const [store] = useDependencies(ServiceFinanceStore);
    const placeholder = 'Type first and last name';
    store.signLoanForm.validate();

    const openLoan = () => {
        window.open(store.loanDocumentInfo!.desktopDownloadLink!);
    };

    return (
        <>
            <div className={classnames('card', Styles.card)}>
                <h3>Sign Agreement</h3>
                <a className={classnames('a', Styles.a)} onClick={openLoan}>
                    Open the loan document
                </a>
                <div className={classnames('col', Styles.col)}>
                    <div className="form-field">
                        <MatField
                            required
                            fullWidth
                            errorColor
                            placeholder={placeholder}
                            label="Applicant"
                            fieldState={store.signLoanForm.$.applicant}
                        />
                    </div>
                </div>
                {store.loanDocumentInfo!.coApplicantSignaturePending && (
                    <div className={classnames('col', Styles.col)}>
                        <div className="form-field">
                            <MatField
                                required
                                fullWidth
                                errorColor
                                placeholder={placeholder}
                                label="Co-Applicant"
                                fieldState={store.signLoanForm.$.coApplicant}
                            />
                        </div>
                    </div>
                )}
            </div>
        </>
    );
});
